import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  offersData: [],
  offersFilterData: [],
  error: "",
  success: false,
  status: "",
};

const fetchOffers = createAsyncThunk("fetch/offers", async () => {
  try {
    const result = await axios.get(
      `${process.env.REACT_APP_CMS_URL}/offers?populate=*`,
      {
        commonHeaderNotRequired: true,
      }
    );
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});
const fetchOffersByFilter = createAsyncThunk(
  "fetch/offers-filter",
  async () => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_CMS_URL}/offer-filters?populate=*`,
        {
          commonHeaderNotRequired: true,
        }
      );
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const offersSlice = createSlice({
  name: "offers",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchOffers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      state.loading = false;
      state.offersData = action?.payload?.data;
      //   state.success = action?.payload;
      state.error = "";
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.loading = false;
      state.offersData = [];
      state.error = action.error.message;
    });

    // Offers by filter
    builder.addCase(fetchOffersByFilter.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOffersByFilter.fulfilled, (state, action) => {
      // console.log(action.payload, "Filter payload");
      state.loading = false;
      state.offersFilterData = action?.payload?.data;
      //   state.success = action?.payload;
      state.error = "";
    });
    builder.addCase(fetchOffersByFilter.rejected, (state, action) => {
      state.loading = false;
      state.offersFilterData = [];
      state.error = action.error.message;
    });
  },
});

export default offersSlice.reducer;
export { fetchOffers, fetchOffersByFilter };
